import { useState } from "react";
import { Camera, Star } from "lucide-react";
import { API_BASE } from "@/lib/api";

const Photo = ({ src, ph, i, big, isCover, onSetCover }) => {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <figure className={`group relative rounded-lg overflow-hidden border bg-slate-950 print-avoid ${isCover ? "border-amber-400/70" : "border-slate-800"} ${big ? "col-span-2 row-span-2" : ""}`} data-testid={`property-photo-${i}`}>
      <img src={src} alt={ph.label} loading="lazy" onError={() => setFailed(true)} className="w-full h-full object-cover aspect-[8/5]" />
      {isCover && <span data-testid={`cover-badge-${i}`} className="no-print absolute top-2 left-2 inline-flex items-center gap-1 rounded-full bg-amber-400 px-2 py-0.5 text-[10px] font-bold text-amber-950"><Star className="h-3 w-3" />Cover</span>}
      {onSetCover && !isCover && (
        <button type="button" data-testid={`set-cover-${i}`} onClick={() => onSetCover(i)}
          className="no-print absolute top-2 left-2 rounded-full bg-black/75 px-2.5 py-1 text-[10px] font-semibold text-white opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity hover:bg-amber-400 hover:text-amber-950">
          Set as cover</button>
      )}
      <figcaption className="absolute bottom-0 inset-x-0 bg-black/75 px-3 py-1.5 text-[11px] text-white">
        {ph.label}<span className="text-slate-300"> · © {ph.attribution || "Google"}</span>
      </figcaption>
    </figure>
  );
};

export const PropertyPhotos = ({ studyId, photos = [], version, basePath = "/studies", coverIdx, onSetCover }) => {
  if (!photos.length) return null;
  const cover = coverIdx != null && coverIdx < photos.length ? coverIdx : 0;
  return (
    <div className="mb-8" data-testid="property-photos">
      <p className="flex items-center gap-2 text-xs uppercase tracking-wider text-slate-500 font-semibold mb-3"><Camera className="h-3.5 w-3.5" />Property photos
        {onSetCover && <span className="no-print normal-case tracking-normal font-normal text-slate-600">· hover a photo to use it on the PDF/Word cover</span>}</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {photos.map((ph, i) => <Photo key={`${version}-${i}`} i={i} ph={ph} big={i === 0} isCover={onSetCover && i === cover} onSetCover={onSetCover}
          src={`${API_BASE}${basePath}/${studyId}/photos/${i}?v=${encodeURIComponent(version || "")}`} />)}
      </div>
    </div>
  );
};
